/**
 * @generated SignedSource<<1469c48163eef1d6872c9ec34d9975f0>>
 * @relayHash b0859ec85298cdcc3abeeb1b76428f06
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 370ec9eee83808f99e9887355ed073323a91ceb9d4f67e1676c11d34f8e236d1

import type { ConcreteRequest } from 'relay-runtime';
export type useIncludeEditorTutorialTemplateGetUserPrivilegesQuery$variables = Record<PropertyKey, never>;
export type useIncludeEditorTutorialTemplateGetUserPrivilegesQuery$data = {
  readonly hasUserAccessAdminRole: boolean | null;
  readonly isSiteAdmin: boolean | null;
  readonly user: {
    readonly confluence: {
      readonly operations: ReadonlyArray<{
        readonly operation: string | null;
        readonly targetType: string | null;
      } | null>;
    } | null;
    readonly id: string | null;
  } | null;
};
export type useIncludeEditorTutorialTemplateGetUserPrivilegesQuery = {
  response: useIncludeEditorTutorialTemplateGetUserPrivilegesQuery$data;
  variables: useIncludeEditorTutorialTemplateGetUserPrivilegesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "ConfluenceUser",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "concreteType": "OperationCheckResult",
            "kind": "LinkedField",
            "name": "operations",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "operation"
              },
              {
                "kind": "ScalarField",
                "name": "targetType"
              }
            ]
          }
        ]
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  },
  {
    "kind": "ScalarField",
    "name": "isSiteAdmin"
  },
  {
    "kind": "ScalarField",
    "name": "hasUserAccessAdminRole"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useIncludeEditorTutorialTemplateGetUserPrivilegesQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useIncludeEditorTutorialTemplateGetUserPrivilegesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "b0859ec85298cdcc3abeeb1b76428f06",
    "id": "370ec9eee83808f99e9887355ed073323a91ceb9d4f67e1676c11d34f8e236d1",
    "metadata": {},
    "name": "useIncludeEditorTutorialTemplateGetUserPrivilegesQuery",
    "operationKind": "query",
    "text": "query useIncludeEditorTutorialTemplateGetUserPrivilegesQuery{user:confluence_atlassianUser(current:true){id,confluence{operations{operation,targetType}}},isSiteAdmin,hasUserAccessAdminRole}"
  }
};
})();

(node as any).hash = "f89395b5bfa711d4abb146bb5f205ba7";

export default node;
